/* eslint-disable */
import * as React from "react";

import { ReportRenderer } from "../../../shared";
import { ReportToolbarGroup } from "../../../components/ReportToolbar";
import { ReportGrid } from "../../../components/ReportGrid";

import { CropsControl } from "../controls/CropsControl";
import { ReferenceYearControl } from "../controls/ReferenceYearControl";
import { CbotDateControl } from "../controls/CbotDateControl";

export default function () {
  return (
    <>
      <ReportToolbarGroup>
        <CropsControl />
        <ReferenceYearControl />
        <div style={{ display: "none" }}>
          <CbotDateControl />
        </div>
      </ReportToolbarGroup>
      <div style={{ display: "none" }}>
        <ReportGrid>
          <ReportRenderer componentId="chart" />
        </ReportGrid>
      </div>
    </>
  );
}
